export const tabList = [
	{
		label: '账号管理',
		name: 'Account',
		auth: 'configure:rules:talentClue:account',
	},
	{
		label: '线索筛选条件',
		name: 'FilterRule',
		auth: 'configure:rules:talentClue:filterRule',
	},
	{
		label: '线索过滤',
		name: 'ClueFilter',
		auth: 'configure:rules:talentClue:filter',
	},
	{
		label: '线索分配',
		name: 'Distribute',
		auth: 'configure:rules:talentClue:distribute',
	},
	{
		label: '联系方式获取',
		name: 'ConcactObtain',
		auth: 'configure:rules:talentClue:concactObtain',
	},
];

// 线索过滤 规则映射关系数组
export const filterMapList = [
	{
		valueKey: 'filterNoContact',
		isArray: true,
		list: [
			{
				value: 2,
				desc: '无公开联系方式',
			},
		],
	},
	{
		valueKey: 'filterExistsTeamSea',
		value: 1,
		desc: '达人已存在团队公海',
	},
	{
		valueKey: 'filterHaveFollow',
		value: 1,
		desc: '达人已有跟进人',
	},
	{
		valueKey: 'filterDisableAnchor',
		value: 1,
		desc: '达人已被标记为"失效状态"',
	},
];

// 通过规则映射关系获取对应中文描述回显
export const getFilterRuleDesc = (conf, data) => {
	const { isArray, list, valueKey, value, desc } = conf;
	if (isArray) {
		return list
			.filter(item => data[valueKey].some(v => v == item.value))
			.map(item => item.desc)
			.join('、');
	} else {
		return value == data[valueKey] ? desc : '';
	}
};

// 账号管理账号状态
export const ACCOUNT_NOT_ENABLED = 0; // 未启用
export const ACCOUNT_RUN = 1; // 运行中

export const accountStatusMap = {
	[ACCOUNT_NOT_ENABLED]: '未启用',
	[ACCOUNT_RUN]: '运行中',
};

export const stopReasonMap = {
	1: '未登录，请及时下载软件并登录',
	2: '浏览器未打开百应后台页面，请在已安装软件的浏览器打开百应后台',
	3: '未开启自动获取达人任务',
	4: '筛选条件已关闭',
	5: '符合筛选条件达人已获取完',
};

// 线索筛选条件类型枚举
export const TELENT_SQUARE = 1; // 达人广场
export const INTELLIGENT = 2; // 智能推荐

export const BUYER_SQUARE = 1; // 买手广场
export const BLOGGER_SQUARE = 2; // 博主广场

export const filterTypeMap = {
	[dataMap.PLATFORM_DY.value]: {
		[TELENT_SQUARE]: {
			desc: '达人广场',
		},
		[INTELLIGENT]: {
			desc: '智能推荐',
		},
	},
	// [dataMap.PLATFORM_XHS.value]: {
	// 	[BUYER_SQUARE]: {
	// 		desc: '买手广场',
	// 	},
	// 	[BLOGGER_SQUARE]: {
	// 		desc: '博主广场',
	// 	},
	// },
	// [dataMap.PLATFORM_SP.value]: {
	// 	[TELENT_SQUARE]: {
	// 		desc: '达人广场',
	// 	},
	// },
	[dataMap.PLATFORM_KS.value]: {
		[TELENT_SQUARE]: {
			desc: '达人广场',
		},
	},
};

// 线索筛选条件 规则状态枚举
export const RULE_STOP = 0;
export const RULE_RUN = 1;

export const statusSearchList = [
	{
		label: '全部',
		value: 0,
	},
	{
		label: '已启用',
		value: 1,
	},
	{
		label: '已禁用',
		value: 2,
	},
];

export const ruleStatusMap = {
	[RULE_STOP]: {
		desc: '已禁用',
		class: 'red-icon',
	},
	[RULE_RUN]: {
		desc: '已启用',
		class: 'green-icon',
	},
};

export const allotStatusMap = {
	NotAllot: 0, // 未分配
	FreeSea: 1, // 收录至团队公海由员工自行认领
	TurnAllot: 2, // 轮流分配
	RandomAllot: 3, //
};

export const radioBtnList = [
	{
		label: '收录至团队公海由员工自行认领',
		value: allotStatusMap.FreeSea,
		drag: false,
	},
	{
		label: '轮流分配',
		value: allotStatusMap.TurnAllot,
		drag: true,
	},
	{
		label: '随机分配',
		value: allotStatusMap.RandomAllot,
		drag: false,
	},
];

export const modifyUrlMap = {
	[dataMap.PLATFORM_DY.value]: {
		[INTELLIGENT]: 'https://buyin.jinritemai.com/dashboard/servicehall/daren-intelligent-recommendation',
		[TELENT_SQUARE]: 'https://buyin.jinritemai.com/dashboard/servicehall/daren-square',
	},
	// [dataMap.PLATFORM_XHS.value]: {
	// 	[INTELLIGENT]: 'https://pgy.xiaohongshu.com/solar/advertiser/patterns/kol',
	// 	[TELENT_SQUARE]: 'https://pgy.xiaohongshu.com/microapp/distribution/live-broadcast/kol',
	// },
	// [dataMap.PLATFORM_SP.value]: {
	// 	[TELENT_SQUARE]: 'https://channels.weixin.qq.com/shop/findersquare/find',
	// },
	[dataMap.PLATFORM_KS.value]: {
		[TELENT_SQUARE]: 'https://cps.kwaixiaodian.com/pc/leader/zone-cps/promoter_square',
	},
};
export const addUrlMap = {
	[dataMap.PLATFORM_DY.value]: 'https://buyin.jinritemai.com/dashboard/servicehall/daren-square',
	// [dataMap.PLATFORM_XHS.value]: 'https://pgy.xiaohongshu.com/microapp/distribution/live-broadcast/kol',
	// [dataMap.PLATFORM_SP.value]: 'https://channels.weixin.qq.com/shop/findersquare/find',
	[dataMap.PLATFORM_KS.value]: 'https://cps.kwaixiaodian.com/pc/leader/zone-cps/promoter_square',
};
// tooltip消息提示文案map
export const tooltipstopReasonTypeMap = {
	0: ' ',
	1: '插件退出登录',
	2: '官方达人广场页面关闭',
	3: '手动关闭任务',
	4: '筛选条件关闭',
};
